import { Truck, Shield, Clock, MapPin, Package, Layers, Navigation, Users, Zap } from 'lucide-react';

export const servicesData = [
  {
    id: 'kurer',
    title: 'Kurerkørsel & ekspres',
    icon: Zap,
    shortDesc: 'Hurtig og sikker levering af pakker og dokumenter direkte til modtageren. Perfekt til hasteopgaver.',
    longDesc: 'Når tiden er en kritisk faktor, står vores kurer- og ekspresservice klar. Vi afhenter og leverer direkte uden unødige stop undervejs. Vi garanterer fuld sporbarhed og personlig overdragelse af dit gods, uanset om det er vigtige dokumenter, reservedele eller medicinsk udstyr.',
    features: ['Direkte levering uden omlastning', 'Hurtig afhentning i Storkøbenhavn', 'Personlig og sikker overdragelse', 'Real-time opdatering undervejs']
  },
  {
    id: 'distribution',
    title: 'Udbredelse & stykgods',
    icon: Truck,
    shortDesc: 'Effektiv distribution af varer og paller til virksomheder med faste ruter og høj leveringssikkerhed.',
    longDesc: 'Vi tilbyder pålidelig distribution af stykgods og pallevarer til både B2B og B2C. Med vores strukturerede ruteplanlægning sikrer vi, at dine varer bliver leveret sikkert og effektivt. Vi håndterer alt fra enkelte paller til hele vognlæs med samme høje præcision.',
    features: ['Dag-til-dag levering', 'Palle- og stykgodshåndtering', 'Optimerede og miljøbevidste ruter', 'Fleksible leveringsvinduer']
  },
  {
    id: 'special',
    title: 'Specialtransport',
    icon: Shield,
    shortDesc: 'Håndtering af følsomt, værdifuldt eller ukurant gods, der kræver særlig opmærksomhed.',
    longDesc: 'Nogle opgaver kræver mere end blot en standard varebil. Vores specialtransport dækker over kørsel med følsomt udstyr, værdifulde varer eller gods med specielle mål. Vi planlægger opgaven ned til mindste detalje og sikrer, at det rette udstyr og ekspertise anvendes.',
    features: ['Særligt uddannede chauffører', 'Skræddersyet fastspænding og beskyttelse', 'Håndtering af følsom elektronik', 'Fuld forsikringsdækning']
  },
  {
    id: 'fast-rute',
    title: 'Faste ruteaftaler',
    icon: Navigation,
    shortDesc: 'Skræddersyede distributionsaftaler med faste ugentlige eller daglige afgange.',
    longDesc: 'For virksomheder med regelmæssige transportbehov tilbyder vi faste ruteaftaler. Det giver maksimal forudsigelighed og ofte en økonomisk fordel. Vi integrerer os i jeres forsyningskæde og fungerer som jeres eksterne transportafdeling med dedikerede biler og chauffører.',
    features: ['Fast tilknyttet chauffør', 'Garanteret kapacitet', 'Økonomisk optimeret løsning', 'Sømløs integration med jeres drift']
  },
  {
    id: 'logistik',
    title: 'Logistikløsninger',
    icon: Layers,
    shortDesc: 'Komplette logistikløsninger, omlastning og koordinering tilpasset din virksomheds behov.',
    longDesc: 'Vi tilbyder skræddersyede logistikløsninger, der optimerer din forsyningskæde. Fra koordinering og omlastning til effektiv distribution sikrer vi, at dit gods håndteres professionelt og leveres præcist til tiden. Vi tilpasser vores processer, så de integreres sømløst med jeres daglige drift.',
    features: ['Skræddersyet logistikstyring', 'Effektiv omlastning og koordinering', 'Sømløs integration med jeres drift', 'Fleksible og skalerbare løsninger']
  }
];

export const advantagesData = [
  {
    title: 'Pålidelighed & punktlighed',
    description: 'Vi forstår, at tid er penge. Derfor overholder vi altid vores aftaler og leverer til tiden. Vores driftssikkerhed er din tryghed.',
    icon: Clock
  },
  {
    title: 'Maksimal fleksibilitet',
    description: 'Ingen opgave er for lille eller for kompleks. Vi tilpasser os hurtigt ændringer og finder løsninger på akutte transportbehov.',
    icon: Zap
  },
  {
    title: 'Professionelle chauffører',
    description: 'Vores chauffører er virksomhedens ansigt udadtil. De er altid præsentable, høflige og uddannet i sikker og professionel godshåndtering.',
    icon: Users
  },
  {
    title: 'Effektiv ruteplanlægning',
    description: 'Vi anvender moderne ruteplanlægningssystemer for at minimere køretid og CO2-udledning. Det sikrer hurtig levering og skåner miljøet.',
    icon: Navigation
  }
];

export const serviceAreas = [
  {
    title: 'Storkøbenhavn & Sjælland',
    description: 'Vi har daglig kørsel og dækker hele Storkøbenhavn samt Sjælland med lynhurtig responstid og kendskab to de lokale ruter.',
    image: 'https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=80,format=auto/assets/ecc7c3d2-b2a3-4a1d-ba29-5687874f0c20/flow-van-city.jpg'
  },
  {
    title: 'Landsdækkende forbindelser',
    description: 'Vi forbinder landsdelene og sikrer, at dit gods kommer sikkert fra Sjælland til Fyn og Jylland med dag-til-dag levering.',
    image: 'https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=80,format=auto/assets/ecc7c3d2-b2a3-4a1d-ba29-5687874f0c20/flow-hero-truck.jpg'
  }
];
